export type RampState = {
  from: number;
  to: number;
  startedAt: number;
  durationMs: number;
};

const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

export function rampValueAt(state: RampState, now: number): number {
  if (!Number.isFinite(state.durationMs) || state.durationMs <= 0) return state.to;
  const t = Math.max(0, Math.min(1, (now - state.startedAt) / state.durationMs));
  return lerp(state.from, state.to, t);
}

export function getRampedValue(
  map: Map<string, RampState>,
  key: string,
  target: number,
  now: number,
  durationMs: number,
  epsilon: number = 1e-6
): number {
  const prev = map.get(key);
  if (!prev) {
    map.set(key, { from: target, to: target, startedAt: now, durationMs: 0 });
    return target;
  }

  const current = rampValueAt(prev, now);
  const nextDur = Number.isFinite(durationMs) ? Math.max(0, durationMs) : 0;

  if (Math.abs(target - prev.to) > epsilon) {
    map.set(key, { from: current, to: target, startedAt: now, durationMs: nextDur });
    return current;
  }

  if (prev.durationMs !== nextDur && Math.abs(current - target) > epsilon) {
    // If ramp duration changes mid-flight, keep continuity from "current".
    map.set(key, { from: current, to: target, startedAt: now, durationMs: nextDur });
    return current;
  }

  return current;
}

